export enum GoogleAdsActionsEnum {
  SET_IS_LOADING = '@googleAds/SET_IS_LOADING',
  SET_IS_EMPTY = '@googleAds/SET_IS_EMPTY',
  SET_TARGETING = '@googleAds/SET_TARGETING',
}

export type GoogleAdsState = { isEmpty: boolean; isLoading: boolean; targeting: string[][] };
